import { IDeveloperBanner } from '../../types/developerBanners';

export function developerBannerReducer(state: IDeveloperBanner | null = null): IDeveloperBanner | null {
  return state;
}
